import dayjs from 'dayjs';

export type TaskDueDateFilter =
  | 'all'
  | 'overdue'
  | 'next_7_days'
  | 'next_30_days';

export function formatDueDateLabel(dueDate: string | null): string {
  if (!dueDate) {
    return 'No due date';
  }

  const parsed = dayjs(dueDate);
  if (!parsed.isValid()) {
    return 'Due date set';
  }

  return parsed.format('MMM D');
}

export function getTimelineStatusLabel(
  dueDate: string | null,
  daysToDue: number | null | undefined,
): string {
  if (!dueDate) {
    return 'No due date';
  }

  if (daysToDue === null || daysToDue === undefined) {
    return 'Due date set';
  }

  if (daysToDue < 0) {
    return 'Overdue';
  }

  if (daysToDue === 0) {
    return 'Due today';
  }

  return `${daysToDue}d left`;
}

export function getDueDateRange(
  dueDateFilter: TaskDueDateFilter,
  now = dayjs(),
) {
  if (dueDateFilter === 'overdue') {
    return {
      due_before: now.toISOString(),
    };
  }

  if (dueDateFilter === 'next_7_days') {
    return {
      due_after: now.startOf('day').toISOString(),
      due_before: now.add(7, 'day').endOf('day').toISOString(),
    };
  }

  if (dueDateFilter === 'next_30_days') {
    return {
      due_after: now.startOf('day').toISOString(),
      due_before: now.add(30, 'day').endOf('day').toISOString(),
    };
  }

  return {
    due_after: undefined,
    due_before: undefined,
  };
}
